import React, { useContext } from "react";
import { StoreContext } from "../context/Store";
import Button from "../parts/Button";
import LanguageSelectBlock from "../parts/LanguageSelectBlock";
import Text from "../parts/Text";

export interface LanguagesProps {}

export interface LanguagesState {}

export const Languages = React.forwardRef<HTMLDivElement, LanguagesProps>(
  (props, ref) => {
    const store = useContext(StoreContext);
    const {
      languages,
      toggleLanguage,
      setLanguageValue,
      tempLanguage,
      addLanguage,
      setTempLanguage,
    } = store;
    return (
      <section id="skills" ref={ref}>
        <Text tag="h2" color="pink" classes="mb-5">
          Języki obce
        </Text>
        <Text tag="h4" classes="mb-2" color="blue">
          Znajomość języków obcych to Twój kolejny atut!
        </Text>
        <Text tag="p" classes="mb-5">
          Zastanów się, jak dobrze posługujesz się danym językiem, bo przyszły
          pracodawca na pewno będzie chciał to zweryfikować. Pamiętaj, że w
          niektórych pracach znajomość języka na poziomie podstawowym też jest
          bardzo przydatna.
        </Text>
        <LanguageSelectBlock
          data={languages}
          toggleLanguage={toggleLanguage}
          setLanguageValue={setLanguageValue}
          value={tempLanguage}
          add={addLanguage}
          onChange={setTempLanguage}
        />
        <div className="d-flex justify-content-end mb-5">
          <Button
            onClick={addLanguage}
            classes="smaller-text pink-border"
            disabled={tempLanguage.length < 3}
          >
            dodaj
          </Button>
        </div>
      </section>
    );
  }
);

export default Languages;
